export const convertStartOfDayISOString = (date?: Date | string) => {
  const dateCopy = !date ? new Date() : new Date(date);
  dateCopy.setUTCHours(0, 0, 0, 0);
  return dateCopy.toISOString();
};
